import * as types from '../actions/zoom-actions-types';


const SET_ZOOM_CALL_IN_SESSION_INITIAL_STATE = {
	isLoading: false,
	isLive: "",
	error: '',
};

export function setZoomCallInSessionReducer(state = SET_ZOOM_CALL_IN_SESSION_INITIAL_STATE, action) {
	switch (action.type) {
		case types.SET_ZOOM_CALL_IN_SESSION:
			return { ...state, isLoading: false, isLive: action.payload };
		default:
			return state;
	}
}